import { AccountOrganization } from 'services/ClaimscoreApiService/Accounts/types';
import { Case } from 'services/ClaimscoreApiService/Cases/types';
import { CasesPermissions } from 'services/ClaimscoreApiService/Permissions/types';
import { UserRole } from 'services/ClaimscoreApiService/shared/types';

export enum RoleLevel {
  organization = 'organization',
  case = 'case',
}

export type UserOrganizationPermissions = AccountOrganization & {
  casesPermissions: CasesPermissions[];
};

export type UserOrgCaseFilters = {
  orgId?: string;
  caseId?: string;
};
export interface UserOrgCaseContextProps {
  userOrganizations: AccountOrganization[];
  userCases: CasesPermissions[];
  selectedOrganization: AccountOrganization;
  selectedCase: Case;
  isCurrentOrgAdmin: boolean;
  isCurrentCaseAdmin: boolean;
  isAdminInAnyCurrentOrgCase: boolean;
  getUserRole: (level: RoleLevel) => UserRole | undefined;
  handleOrganizationSelect: (selectedOrganization: AccountOrganization) => void;
  handleCaseSelect: (selectedCase: CasesPermissions) => void;
  isLoading: boolean;
  filters: UserOrgCaseFilters;
}
